import type { ReactElement, ReactNode } from 'react';

import styles from './PrimaryShaderGradient.module.css';

/**
 * Перенос `lib/src/presentation/widgets/primary_text_gradient.dart`.
 *
 * ShaderMask с вертикальным градиентом: прозрачно сверху, непрозрачно
 * посередине, прозрачно снизу — содержимое «растворяется» у обоих краёв.
 */
export interface PrimaryShaderGradientProps {
  enable?: boolean;
  children: ReactNode;
  className?: string;
}

export function PrimaryShaderGradient(props: PrimaryShaderGradientProps): ReactElement {
  const { enable = true, children, className } = props;
  const classNames = [styles.root, enable ? styles.enabled : null, className];
  return <div className={classNames.filter(Boolean).join(' ')}>{children}</div>;
}
